const FEATURES = {
  calls: ['unicovida', 'teste'],
  card_number: ['suasaude'],
  whatsapp: ['saudedovale', 'medleste'],
  partner_category: ['saudedovale', 'medleste', 'teste'],
  insurance_report: ['unicovida', 'teste', 'saudedovale'],
  contacts: ['saudedovale', 'medleste', 'teste'],
  procedure_authorizations: ['unicovida']
};

const SUBDOMAIN = window.location.host.split('.')[0];

export default {
  features: FEATURES,
  allows: feature => {
    return FEATURES[feature].includes(SUBDOMAIN);
  }
};
